import { createMiddlewareAction } from './createMiddlewareAction'
import { endpoints } from '../api/endpoints'
import { lgpdPolicyTypes } from '../constantes/actionTypes'

export const lgpdPolicyActions = {
  MarkAsReadLgpdPolicy: (ref) =>
    createMiddlewareAction({
      successType: lgpdPolicyTypes.MARK_AS_READ_LGPD_POLICY_SUCCESS,
      failureType: lgpdPolicyTypes.MARK_AS_READ_LGPD_POLICY_FAILURE,
      method: 'GET',
      endpoint: endpoints.READ_LGPD_POLICY(ref),
    }),

  AcceptLgpdPolicy: (ref) =>
    createMiddlewareAction({
      successType: lgpdPolicyTypes.ACCEPT_LGPD_POLICY_SUCCESS,
      failureType: lgpdPolicyTypes.ACCEPT_LGPD_POLICY_FAILURE,
      method: 'GET',
      endpoint: endpoints.ACCEPT_LGPD_POLICY(ref),
    }),

  RejectLgpdPolicy: (ref) =>
    createMiddlewareAction({
      successType: lgpdPolicyTypes.REJECT_LGPD_POLICY_SUCCESS,
      failureType: lgpdPolicyTypes.REJECT_LGPD_POLICY_FAILURE,
      method: 'GET',
      endpoint: endpoints.REJECT_LGPD_POLICY(ref),
    }),
}
